import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

const LegalLinks = ({ showTerms = false }) => (
  <div className="mt-6 flex w-full flex-row justify-center gap-4">
    {showTerms && (
      <Link
        to="/terms-and-conditions"
        className="text-sm font-semibold uppercase leading-[14px] tracking-[1.5px] text-blue-800 hover:text-blue-900"
      >
        Terms and Conditions
      </Link>
    )}

    <Link
      to="/privacy-policy"
      className="text-sm font-semibold uppercase leading-[14px] tracking-[1.5px] text-blue-800 hover:text-blue-900"
    >
      Privacy Policy
    </Link>
  </div>
)

LegalLinks.propTypes = {
  showTerms: PropTypes.bool,
}

export default LegalLinks
